import { useState } from "react";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      const res = await fetch(`${API}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: "Study Tips Signup",
          email: email.trim(),
          message: "Please add me to the free weekly Study Tips list. I signed up on the website.",
        }),
      });
      if (!res.ok) throw new Error("failed");
      setDone(true);
    } catch {
      toast.error("Could not sign you up. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid="newsletter-signup" className="border-t border-white/10 bg-[#050505] px-6 py-16 md:px-12">
      <div className="mx-auto max-w-[720px] text-center">
        <span className="text-xs uppercase tracking-[0.4em] text-[#7C3AED]">Free Weekly Study Tips</span>
        <h2 className="mt-3 font-display text-3xl uppercase tracking-tight text-white sm:text-4xl">
          One tip a week. Real progress.
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-white/55 md:text-base">
          Join Dr. Louden's free list — a short algebra tip, study habit, or leadership thought in
          your inbox each week. No spam, unsubscribe anytime.
        </p>
        {done ? (
          <p data-testid="newsletter-success" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-emerald-400">
            <CheckCircle2 size={18} /> You're on the list — watch your inbox for the first tip.
          </p>
        ) : (
          <form onSubmit={submit} data-testid="newsletter-form" className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              data-testid="newsletter-email"
              className="w-full rounded-full border border-white/15 bg-black/40 px-5 py-3 text-sm text-white placeholder-white/30 outline-none focus:border-[#7C3AED]"
            />
            <button
              type="submit"
              disabled={sending}
              data-testid="newsletter-submit"
              className="magnetic-btn inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#7C3AED] px-6 py-3 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black disabled:opacity-50"
            >
              <Mail size={14} /> {sending ? "Joining…" : "Join Free"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
